import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";

// Pages
import HomePage from "./pages/HomePage";
import PlanosPage from "./pages/PlanosPage";
import CondominiosPage from "./pages/CondominiosPage";
import EmpresasPage from "./pages/EmpresasPage";
import MapaPage from "./pages/MapaPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/planos" element={<PlanosPage />} />
            <Route path="/condominios" element={<CondominiosPage />} />
            <Route path="/empresas" element={<EmpresasPage />} />
            <Route path="/mapa" element={<MapaPage />} />
          </Routes>
        </div>
        <Footer />
        <ChatWidget />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
